import { gql } from 'apollo-angular';
import { subDomainItemFragment } from '../sub-domain/sub-domain.fragments';

export const parentDomainMinimalFragment = gql`
  fragment ParentDomainMinimal on ParentDomain {
    id
    title
  }
`;

export const parentDomainItemFragment = gql`
  fragment ParentDomainItemFragment on ParentDomain {
    ...ParentDomainMinimal

    subDomains {
      nodes {
        ...SubDomainItem
      }
    }
  }
  ${parentDomainMinimalFragment}
  ${subDomainItemFragment}
`;
